import React, { useState, useEffect, useContext } from 'react';

import { useRouter } from 'next/router';

import AuthenticationPageContext from '@components/lpc/Authentication/AuthenticationPageContext';
import EmailSentConfirmation from '@components/lpc/Authentication/LeftSide/EmailSentConfirmation/EmailSentConfirmation';
import LeftSide from '@components/lpc/Authentication/LeftSide/LeftSide';
import LoginLeft from '@components/lpc/Authentication/LeftSide/Login/Login';
import TfaConfirmation from '@components/lpc/Authentication/LeftSide/Login/TfaConfirmation/TfaConfirmation';
import LostPassword from '@components/lpc/Authentication/LeftSide/LostPassword/LostPassword';
import UpdatePassword from '@components/lpc/Authentication/LeftSide/UpdatePassword/UpdatePassword';
import UpdatePasswordConfirmation from '@components/lpc/Authentication/LeftSide/UpdatePasswordConfirmation/UpdatePasswordConfirmation';
import LoginRight from '@components/lpc/Authentication/RightSide/LoginSlider/LoginSlider';
import RightSide from '@components/lpc/Authentication/RightSide/RightSide';
import UserContext from '@components/lpc/Context/User/UserContext';
import Layout from '@components/lpc/Layout/Layout';
import { ROUTE } from '@services/http/Route';
import ObjectService from '@services/utils/ObjectService';

import css from './Authentication.module.scss';

const Authentication = () => {
    const [uniqUP, setUniqUP] = useState(null);
    const userContext = useContext(UserContext);
    const { userAccount } = userContext;
    const router = useRouter();

    useEffect(() => {
        setUniqUP(new URLSearchParams(window.location.search).get('uniqUP'));
    }, []);

    useEffect(() => {
        if (ObjectService.hasContent(userAccount) && !new URLSearchParams(window.location.search).get('uniqUP')) {
            // @ts-ignore
            router.query?.urlReturn ? window.location.assign(router.query.urlReturn) : router.push(ROUTE.LPC.HOME);
        }
    }, [userAccount]);

    return (
        <AuthenticationPageContext.Provider>
            <AuthenticationPageContext.Consumer>
                {({ pages, page, setPage, phone, email, password, stayConnected, tfaType }) => {
                    if (uniqUP && page !== 7) {
                        setPage(pages.newPassword);
                    }
                    return (
                        <Layout hideNavbar hideFooter>
                            <div className={css.authenticationPageWrapper}>
                                {page === pages.loginConfirmation ? (
                                    <TfaConfirmation
                                        tfaType={tfaType}
                                        email={email}
                                        password={password}
                                        stayConnected={stayConnected}
                                        phoneNumber={phone}
                                    />
                                ) : (
                                    <>
                                        <div className={css.leftSide}>
                                            <LeftSide>
                                                {page === pages.login && <LoginLeft />}
                                                {page === pages.lostPassword && <LostPassword />}
                                                {page === pages.emailSentConfirmation && (
                                                    <EmailSentConfirmation fromDashboard={false} />
                                                )}
                                                {page === pages.newPassword && <UpdatePassword uniqUP={uniqUP} />}
                                                {page === pages.updatePasswordConfirmation && (
                                                    <UpdatePasswordConfirmation />
                                                )}
                                            </LeftSide>
                                        </div>
                                        <div className={css.rightSide}>
                                            <RightSide>
                                                <LoginRight />
                                            </RightSide>
                                        </div>
                                    </>
                                )}
                            </div>
                        </Layout>
                    );
                }}
            </AuthenticationPageContext.Consumer>
        </AuthenticationPageContext.Provider>
    );
};

export default Authentication;
